import alertCircle from "./icons/alertCircle.js";
import angleDown from "./icons/angleDown.js";
import arrowDown from "./icons/arrowDown.js";
import arrowLeft from "./icons/arrowLeft.js";
import arrowRight from "./icons/arrowRight.js";
import arrowUp from "./icons/arrowUp.js";
import check from "./icons/check.js";
import chevronDown from "./icons/chevronDown.js";
import chevronLeft from "./icons/chevronLeft.js";
import chevronRight from "./icons/chevronRight.js";
import close from "./icons/close.js";
import creditCard from "./icons/creditCard.js";
import download from "./icons/download";
import edit from "./icons/edit";
import eye from "./icons/eye.js";
import eyeSlash from "./icons/eyeSlash.js";
import facebook from "./icons/facebook.js";
import file from "./icons/file.js";
import fileText from "./icons/fileText.js";
import google from "./icons/google.js";
import information from "./icons/information.js";
import linkedin from "./icons/linkedin.js";
import lock from "./icons/lock.js";
import mail from "./icons/mail.js";
import menu from "./icons/menu.js";
import onboardingArrow from "./icons/onboardingArrow.js";
import phone from "./icons/phone.js";
import settings from "./icons/settings.js";
import user from "./icons/user.js";
import x from "./icons/x.js";

// Braingineers Icons
import add from "./icons/add.js";
import allTests from "./icons/allTests.js";
import brainrocket from "./icons/brainrocket.js";
import benchmark from "./icons/benchmark.js";
import department from "./icons/department.js";
import company from "./icons/company.js";
import support from "./icons/support.js";
import journey from "./icons/journey.js";
import exportPdf from "./icons/exportPDF.js";
import members from "./icons/members.js";
import account from "./icons/account.js";
import overview from "./icons/overview.js";
import pageInsights from "./icons/pageInsights.js";
import videos from "./icons/videos.js";
import elements from "./icons/elements.js";
import professional from "./icons/professional.js";
import journeyinsights from "./icons/journeyinsights.js";
import targetGroupCustom from "./icons/targetGroupCustom.js";
import targetGroup from "./icons/targetGroup.js";
import muscleBrain from "./icons/muscleBrain.js";
import trashcan from "./icons/delete.js";
import info from "./icons/info.js";

export default {
  add,
  info,
  support,
  muscleBrain,
  allTests,
  trashcan,
  targetGroupCustom,
  targetGroup,
  brainrocket,
  account,
  benchmark,
  journeyinsights,
  professional,
  department,
  elements,
  company,
  journey,
  exportPdf,
  members,
  overview,
  pageInsights,
  videos,
  alertCircle,
  angleDown,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  check,
  chevronDown,
  chevronLeft,
  chevronRight,
  close,
  creditCard,
  download,
  edit,
  eye,
  eyeSlash,
  facebook,
  file,
  fileText,
  google,
  information,
  linkedin,
  lock,
  mail,
  menu,
  onboardingArrow,
  phone,
  settings,
  user,
  x
};
